import { render, staticRenderFns } from "./ViewCoupon.vue?vue&type=template&id=2bb9c976&scoped=true"
import script from "./ViewCoupon.vue?vue&type=script&lang=js"
export * from "./ViewCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb9c976",
  null
  
)

export default component.exports